import React, { useState, useRef } from "react";
import { Navigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import { setMessage } from "../../actions/message";
import { getCompany, upsertCompany } from "../../actions/company";
import { useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import { Divider, Button } from "@mui/material";
import CountrySelect from "../../CountrySelect";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const Company = (props) => {

  let companyLoaded = false;
  const dispatch = useDispatch();

  const form = useRef();
  const { message } = useSelector(state => state.message);
  const [loading, setLoading] = useState(false);
  const checkBtn = useRef();

  const { company: company } = useSelector((state) => state.company);

  const [Name, setName] = useState('');
  const [Address, setAddress] = useState('');
  const [Address2, setAddress2] = useState('');
  const [Locality, setLocality] = useState('');
  const [Zipcode, setZipcode] = useState('');
  const [PhoneNumber, setPhoneNumber] = useState('');
  const [Mobile, setMobile] = useState('');
  const [Email, setEmail] = useState('');
  const [Website, setWebsite] = useState('');
  const [Country, setCountry] = useState('');

  const onChangeName = (e) => { setName(e.target.value); };
  const onChangeAddress = (e) => { setAddress(e.target.value); };
  const onChangeAddress2 = (e) => { setAddress2(e.target.value); };
  const onChangeLocality = (e) => { setLocality(e.target.value); };
  const onChangeZipcode = (e) => { setZipcode(e.target.value); };
  const onChangePhoneNumber = (e) => { setPhoneNumber(e.target.value); };
  const onChangeMobile = (e) => { setMobile(e.target.value); };
  const onChangeEmail = (e) => { setEmail(e.target.value); };
  const onChangeWebsite = (e) => { setWebsite(e.target.value); };

  useEffect(() => {
    if (!companyLoaded) {
      dispatch(getCompany()).then(() => {
        setName(company.name);
        setAddress(company.adress);
        setAddress2(company.adress2);
        setLocality(company.locality);
        setZipcode(company.zipcode);
        setPhoneNumber(company.phoneNumber);
        setMobile(company.mobile);
        setEmail(company.email);
        setWebsite(company.website);
        setCountry(company.country);
        companyLoaded = true;
      }).catch(() => { });
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {

      let company_tmp = company != null ? company : {};

      company_tmp.name = Name;
      company_tmp.adress = Address;
      company_tmp.adress2 = Address2;
      company_tmp.locality = Locality;
      company_tmp.zipcode = Zipcode;
      company_tmp.phoneNumber = PhoneNumber;
      company_tmp.mobile = Mobile;
      company_tmp.website = Website;
      company_tmp.email = Email;
      company_tmp.country = Country;
      
      dispatch(upsertCompany(company_tmp))
        .then(() => {
          toast.success(`Company updated successfuly`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER })
          props.onHide();
        }).catch(() => {
          setMessage("An Error occured while updating the company. Try again later.")
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  if (company != null) {
    return (

      <div className="container">
        <div className="col-md-12">
          <Form onSubmit={handleSubmit} ref={form}>
            <div className="form-group">
              <label htmlFor="name">Company name</label>
              <Input
                type="text"
                className="form-control"
                name="name"
                value={Name}
                onChange={(e) => onChangeName(e)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="address">Address</label>
              <div className="row">
                <div className="col-7">
                  <Input
                    type="text"
                    className="form-control"
                    name="address"
                    value={Address}
                    onChange={(e) => onChangeAddress(e)}
                  />
                </div>
                <div className="col">
                  <Input
                    type="text"
                    className="form-control"
                    name="adress"
                    value={Address2}
                    onChange={(e) => onChangeAddress2(e)}
                  />
                </div>
              </div>
            </div>

            <div className="form-group row">
              <div className="col-4">
                <label htmlFor="email">Locality</label>
                <Input
                  type="text"
                  className="form-control"
                  name="locality"
                  value={Locality}
                  onChange={(e) => onChangeLocality(e)}
                />
              </div>
              <div className="col-4">
                <label htmlFor="zipcode">Zipcode</label>
                <Input
                  type="text"
                  className="form-control"
                  name="zipcode"
                  value={Zipcode}
                  onChange={(e) => onChangeZipcode(e)}
                />
              </div>
              <div className="col-4">
                <label htmlFor="country">Country</label>
                <CountrySelect setValue={setCountry} selectedCode={Country} />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-auto">
                <label htmlFor="phonenumber">Phone Number</label>
                <Input
                  type="text"
                  className="form-control"
                  name="phonenumber"
                  value={PhoneNumber}
                  onChange={(e) => onChangePhoneNumber(e)}
                />
              </div>
              <div className="col-auto">
                <label htmlFor="phonenumber">Mobile</label>
                <Input
                  type="text"
                  className="form-control"
                  name="mobile"
                  value={Mobile}
                  onChange={(e) => onChangeMobile(e)}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <Input
                type="text"
                className="form-control"
                name="email"
                value={Email}
                onChange={(e) => onChangeEmail(e)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="website">Website</label>
              <Input
                type="url"
                className="form-control"
                name="website"
                value={Website}
                onChange={(e) => onChangeWebsite(e)}
              />
            </div>

            <Modal.Footer>
              <Button variant="contained" disabled={loading} onClick={handleSubmit}>
                {loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span>Save</span>
              </Button>


              {message && (
                <div className="form-group">
                  <div className="alert alert-danger" role="alert">
                    {message}
                  </div>
                </div>
              )}
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Modal.Footer>
          </Form>
        </div>
      </div>
    );
  } else {
    return <div>???</div>
  }
};

export default Company;